import { useEchoRevalidate } from './useEchoRevalidate';
import { useEchoState } from './useEchoState';
import { useEchoSubmit } from './useEchoSubmit';

import type { EchoSnapshot, UseEchoReturn } from '../types';

export function useEcho(snapshot: EchoSnapshot): UseEchoReturn {
  const [state, setState] = useEchoState(snapshot);
  const onSubmit = useEchoSubmit(setState);

  useEchoRevalidate(snapshot, setState);

  if (state.status === 'error') {
    throw state.error;
  }

  return { echo: state.echo, isPreview: state.isPreview, onSubmit };
}
